/**
 * Shared "current Colyseus room" handle. RealmClient and DungeonClient
 * both register their room here on connect, so the rest of the app can
 * call `getActiveRoom()?.send(...)` without knowing which room type
 * the player is in right now.
 */

import type { Room } from 'colyseus.js';

let active: Room | null = null;

export function setActiveRoom(r: Room | null): void {
  active = r;
}

export function getActiveRoom(): Room | null {
  return active;
}
